import React from 'react';

const NoVCardSelected = (props) => { // take props as a parameter
    return (
        <div className="vcard">
            <h2>No VCard Selected</h2>
            <p>{props.errorMessage}</p> {/* use the errorMessage prop */}
        </div>
    );
};

export default NoVCardSelected;